import { Link as RouterLink } from 'react-router-dom';
import { Stack, TextLink } from 'components/ui';
import { AuthFooterPrompt } from 'pages/Auth/components';
import type { SignInFooterProps } from './SignInFooter.types';
import {
  SIGN_IN_FOOTER_PROMPT,
  SIGN_IN_FOOTER_SIGN_UP_LABEL,
  SIGN_IN_FOOTER_SKIP_LABEL,
} from '../../SignIn.constants';

const SignInFooter = ({
  isIdentifierSubmitting,
  isPasswordSubmitting,
  safeReturnTo,
  showFooterSkip,
  showSignUpFooter,
  signUpHref,
}: SignInFooterProps) => {
  if (!showSignUpFooter || isIdentifierSubmitting) {
    return null;
  }

  return (
    <Stack
      alignItems={{ sm: 'center', xs: 'stretch' }}
      direction={{ sm: 'row', xs: 'column' }}
      justifyContent={showFooterSkip ? 'space-between' : 'center'}
      spacing={1.5}
      width="100%"
    >
      <AuthFooterPrompt
        disabled={isPasswordSubmitting}
        linkLabel={SIGN_IN_FOOTER_SIGN_UP_LABEL}
        prompt={SIGN_IN_FOOTER_PROMPT}
        to={signUpHref}
      />
      {showFooterSkip ? (
        <TextLink<typeof RouterLink>
          component={RouterLink}
          disabled={isPasswordSubmitting}
          replace
          sx={{ textAlign: { sm: 'right', xs: 'center' } }}
          to={safeReturnTo ?? '/'}
          variant="body2"
          visualVariant="anchor"
        >
          {SIGN_IN_FOOTER_SKIP_LABEL}
        </TextLink>
      ) : null}
    </Stack>
  );
};

export default SignInFooter;
